<template>
  <v-container>
    <v-btn color="indigo" @click="tdialog = true">
      <v-icon medium color="white">add</v-icon>
      <span class="white--text">Add a Trainer</span>
    </v-btn>
    <v-btn small fab color="white" router to="/dashboard">
      <v-icon medium color="red">close</v-icon>
    </v-btn>
    <v-card>
      <h3 class="grey darken-3 white--text pa-1">
        <v-dialog v-model="tdialog" max-width="800">
          <h4 class="headline teal white--text pa-2">New Trainer Bio-Data</h4>
          <v-card class="pa-3">
            <v-card-title class="headline">Please complete this form to submit a new trainer</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="indigo darken-1 white--text" @click="addTrainer">Submit</v-btn>
              <v-btn color="indigo darken-1 white--text" @click="tdialog = false">Cancel</v-btn>
            </v-card-actions>
            <h3 class="grey darken-3 white--text pa-2">Name and Contact details</h3>
            <v-alert :value="true" v-if="success" :color="color">
              <h4>{{message}}</h4>
            </v-alert>
            <v-form ref="form3" v-model="valid" lazy-validation>
              <v-text-field
                v-model="contact"
                label="Name of the Trainer"
                prepend-icon="contacts"
                :rules="inputRules"
              ></v-text-field>
              <v-text-field
                v-model="email"
                label="Email Address"
                prepend-icon="contact_mail"
                :rules="emailRules"
              ></v-text-field>
              <v-text-field
                v-model="phone"
                label="Mobile Number"
                prepend-icon="contact_phone"
                :rules="inputRules"
              ></v-text-field>

              <h3
                class="grey darken-3 white--text pa-2"
              >Areas of Expertise (This trainer is experienced in the following areas)</h3>
              <v-layout row wrap>
                <v-checkbox
                  v-model="tarea"
                  v-for="selects in selected"
                  :key="selects.id"
                  :label="selects.category"
                  :value="selects.category"
                ></v-checkbox>
              </v-layout>
              <h3 class="grey darken-3 white--text pa-2">Affiliation to your organisation</h3>
              <v-layout row wrap="true">
                <v-checkbox v-model="trainer" label="Staff Member" value="Staff Member"></v-checkbox>
                <v-checkbox
                  v-model="trainer"
                  label="Freelance Consultant"
                  value="Freelance Consultant"
                ></v-checkbox>
                <v-checkbox v-model="trainer" label="Pro Bono" value="Pro Bono"></v-checkbox>
                <v-checkbox v-model="trainer" label="Other" value="Other"></v-checkbox>
              </v-layout>
            </v-form>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="indigo darken-1 white--text" @click="addTrainer">Submit</v-btn>
              <v-btn color="indigo darken-1 white--text" @click="tdialog = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>TRAINERS OF VARIOUS TRAININGS BY PWG MEMBERS
      </h3>
    </v-card>
    <v-layout row>
      <v-flex xs12 md4 class="grey lighten-3 pa-2">NAME & AFFILIATION</v-flex>
      <v-flex xs12 md4 class="grey lighten-3 pa-2">AREA OF TRAINING</v-flex>
      <v-flex xs12 md4 class="grey lighten-3 pa-2">CONTACTS</v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-card flat v-for="(train, i) in trainers" :key="train.id">
      <v-layout v-if="!saved" row wrap>
        <v-flex xs12 md4 class="white pa-2">
          <div class="pa-1">
            <h5>{{i+1}}. {{train.tname}} , {{train.reference}}</h5>
          </div>
        </v-flex>
        <v-flex xs12 md4 class="white pa-2">
          <div class="pl-3" v-for="(trainer,i) in train.specialisation" :key="trainer.id">
            <h5>{{i+1}}. {{trainer}} Trainer</h5>
          </div>
        </v-flex>
        <v-flex xs12 md4 class="white pa-2">
          <h5>Mobile: {{train.tphone}}</h5>
          <h5>Email: {{train.temail}}</h5>
        </v-flex>
      </v-layout>
      <v-divider class="teal lighten-4"></v-divider>
    </v-card>
  </v-container>
</template>
<script>
import { db, auth, functions } from "@/fb";
export default {
  data() {
    return {
      color: "green",
      success: false,
      message: "",
      valid: false,
      //TRAINERS
      tdialog: false,
      selected: [],
      trainer: [],
      trainers: [],
      temail: "",
      tphone: "",
      tcontact: "",
      tcategory: "",
      reference: "",
      tname: "",
      item: "",
      tarea: [],
      contact: "",
      email: "",
      saved: false,
      phone: "",
      inputRules: [
        v => !!v || "This field is required",
        v => v.length >= 10 || "Minimum length is 10 characters"
      ],
      passRules: [
        v => !!v || "This field is required",
        v => v.length >= 8 || "Minimum length is 8 characters"
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    this.userid = auth.currentUser.uid;
    db.collection("members")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (this.userid == doc.id) {
            this.reference = doc.data().name;
          }
        });
      });

    db.collection("trainers").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.trainers.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });

    db.collection("t_categories").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.selected.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });
  },
  methods: {
    addTrainer() {
      if (
        this.reference == "" ||
        this.contact == "" ||
        this.phone == "" ||
        this.email == "" ||
        this.tarea == "" ||
        this.trainer == ""
      ) {
        this.message = "Please add all the trainer details";
        this.color = "red";
        this.success = true;
        this.tdialog = true;
      } else {
        db.collection("trainers")
          .add({
            reference: this.reference,
            tname: this.contact,
            tphone: this.phone,
            temail: this.email,
            specialisation: this.tarea,
            affiliation: this.trainer
          })
          .then(docRef => {
            this.tdialog = false;
            this.success = false;
            this.contact = "";
            this.phone = "";
            this.email = "";
            this.reference = "";
            this.tcategory = "";
            this.tarea = "";
            this.trainer = "";
          });
      }
    }
  }
};
</script>
